var map = {
	"./Default-Images/Defaul3.png": 78927,
	"./Default-Images/Default1.png": 13115,
	"./Default-Images/Default4.png": 6134,
	"./Default-Images/Defualt2.png": 74064,
	"./Default-Images/Webp/Defaul3.webp": 78533,
	"./Default-Images/Webp/Default1.webp": 44407,
	"./Default-Images/Webp/Default4.webp": 72088,
	"./Default-Images/Webp/Defualt2.webp": 18702,
	"./avatars/default/animoji-inactive-1.webp": 16429,
	"./avatars/default/animoji-inactive-10.webp": 31443,
	"./avatars/default/animoji-inactive-11.webp": 9232,
	"./avatars/default/animoji-inactive-12.webp": 3485,
	"./avatars/default/animoji-inactive-2.webp": 42720,
	"./avatars/default/animoji-inactive-3.webp": 25763,
	"./avatars/default/animoji-inactive-4.webp": 49054,
	"./avatars/default/animoji-inactive-5.webp": 43737,
	"./avatars/default/animoji-inactive-6.webp": 64060,
	"./avatars/default/animoji-inactive-7.webp": 64684,
	"./avatars/default/animoji-inactive-8.webp": 45866,
	"./avatars/default/animoji-inactive-9.webp": 13397,
	"./avatars/selected/animoji-active-1.webp": 42266,
	"./avatars/selected/animoji-active-10.webp": 48006,
	"./avatars/selected/animoji-active-11.webp": 17761,
	"./avatars/selected/animoji-active-12.webp": 99588,
	"./avatars/selected/animoji-active-2.webp": 2715,
	"./avatars/selected/animoji-active-3.webp": 17368,
	"./avatars/selected/animoji-active-4.webp": 74193,
	"./avatars/selected/animoji-active-5.webp": 55318,
	"./avatars/selected/animoji-active-6.webp": 80791,
	"./avatars/selected/animoji-active-7.webp": 96084,
	"./avatars/selected/animoji-active-8.webp": 10557,
	"./avatars/selected/animoji-active-9.webp": 66994,
	"./back-btn.png": 11746,
	"./dashboard/cricket-asset.png": 19541,
	"./dashboard/cricket-icon.png": 38026,
	"./dashboard/dribble-asset.png": 68718,
	"./dashboard/f1-asset.png": 66543,
	"./dashboard/f1-icon.png": 97884,
	"./dashboard/fixture-icon.png": 72900,
	"./dashboard/logo.png": 34662,
	"./dashboard/rugby-asset.png": 11409,
	"./dashboard/rugby-icon.png": 37182,
	"./dashboard/soccer-icon.png": 14746,
	"./dashboard/trending-icon.png": 61676,
	"./dashboard/trivia-container.png": 81060,
	"./dashboard/unbeaten-banner.png": 69512,
	"./dashboard/view-all-icon.png": 71938,
	"./default-badge.webp": 26272,
	"./fixtures/expand-icon.png": 21041,
	"./fixtures/hide-icon.png": 46033,
	"./icons/cricket-club-icon.png": 80185,
	"./icons/f1-club-icon.png": 34191,
	"./icons/fixtures-icon.png": 24401,
	"./icons/home-icon.png": 87532,
	"./icons/live-tv-icon.png": 48884,
	"./icons/lock-icon.png": 32380,
	"./icons/news-icon.png": 63484,
	"./icons/profile-icon.png": 78278,
	"./icons/question-indicator-active.png": 42190,
	"./icons/question-indicator-inactive.png": 33563,
	"./icons/quotes-icon.png": 57694,
	"./icons/rugby-club-icon.png": 1513,
	"./icons/soccer-ball-icon.png": 14572,
	"./icons/soccer-club-icon.png": 83529,
	"./logos/cricket/afghanistan-logo-icon.png": 61175,
	"./logos/cricket/australia-logo-icon.png": 33095,
	"./logos/cricket/australia-logo-icon.webp": 42660,
	"./logos/cricket/bangladesh-logo-icon.png": 4682,
	"./logos/cricket/bangladesh-logo-icon.webp": 47483,
	"./logos/cricket/boland-logo-icon.webp": 30044,
	"./logos/cricket/boland-rocks-logo-icon.webp": 55471,
	"./logos/cricket/chennai-super-kings-logo-icon.png": 42456,
	"./logos/cricket/default-cricketzone-logo-icon.webp": 20507,
	"./logos/cricket/delhi-capitals-logo-icon.png": 50545,
	"./logos/cricket/dolphins-logo-icon.webp": 43707,
	"./logos/cricket/durban's-super-giants-logo-icon.png": 15286,
	"./logos/cricket/england-logo-icon.png": 35254,
	"./logos/cricket/england-logo-icon.webp": 87167,
	"./logos/cricket/gujarat-titans-logo-icon.png": 58713,
	"./logos/cricket/india-logo-icon.png": 43264,
	"./logos/cricket/india-logo-icon.webp": 65325,
	"./logos/cricket/ireland-logo-icon.png": 40392,
	"./logos/cricket/joburg-super-kings-logo-icon.png": 1475,
	"./logos/cricket/knights-logo-icon.webp": 99240,
	"./logos/cricket/kolkata-knight-riders-logo-icon.png": 96302,
	"./logos/cricket/kwazulu-natal-inland-logo-icon.webp": 9951,
	"./logos/cricket/lions-logo-icon.webp": 15341,
	"./logos/cricket/lucknow-super-giants-logo-icon.png": 60927,
	"./logos/cricket/mi-cape-town-logo-icon.png": 63898,
	"./logos/cricket/mumbai-indians-logo-icon.png": 49679,
	"./logos/cricket/netherlands-logo-icon.png": 79841,
	"./logos/cricket/new-zealand-logo-icon.png": 18131,
	"./logos/cricket/new-zealand-logo-icon.webp": 15800,
	"./logos/cricket/north-west-dragons-logo-icon.webp": 19150,
	"./logos/cricket/paarl-royals-logo-icon.png": 91804,
	"./logos/cricket/pakistan-logo-icon.png": 63640,
	"./logos/cricket/pakistan-logo-icon.webp": 88709,
	"./logos/cricket/pretoria-capitals-logo-icon.png": 2023,
	"./logos/cricket/punjab-kings-logo-icon.png": 55886,
	"./logos/cricket/rajasthan-royals-logo-icon.png": 71350,
	"./logos/cricket/royal-challengers-bengaluru-logo-icon.png": 61735,
	"./logos/cricket/south-africa-logo-icon.png": 1339,
	"./logos/cricket/south-africa-logo-icon.webp": 51008,
	"./logos/cricket/sri-lanka-logo-icon.png": 59351,
	"./logos/cricket/sri-lanka-logo-icon.webp": 97140,
	"./logos/cricket/sunrisers-eastern-cape-logo-icon.png": 39048,
	"./logos/cricket/sunrisers-hyderabad-logo-icon.png": 82362,
	"./logos/cricket/titans-logo-icon.webp": 23613,
	"./logos/cricket/warriors-logo-icon.webp": 17437,
	"./logos/cricket/west-indies-logo-icon.png": 79515,
	"./logos/cricket/west-indies-logo-icon.webp": 80992,
	"./logos/cricket/western-province-logo-icon.webp": 26831,
	"./logos/cricket/zimbabwe-logo-icon.png": 54542,
	"./logos/motorsport/afghanistan-logo-icon.png": 43673,
	"./logos/motorsport/aprilia-racing-logo-icon.webp": 11199,
	"./logos/motorsport/australia-logo-icon.png": 38381,
	"./logos/motorsport/bangladesh-logo-icon.png": 13436,
	"./logos/motorsport/default-motorsportzone-logo-icon.webp": 16051,
	"./logos/motorsport/ducati-lenovo-logo-icon.webp": 10380,
	"./logos/motorsport/durban's-super-giants-logo-icon.png": 36428,
	"./logos/motorsport/england-logo-icon.png": 83288,
	"./logos/motorsport/f1-logo-large.png": 6410,
	"./logos/motorsport/f1-logo.png": 94464,
	"./logos/motorsport/gresini-racing-logo-icon.webp": 82678,
	"./logos/motorsport/honda-repsol-logo-icon.webp": 78314,
	"./logos/motorsport/india-logo-icon.png": 86858,
	"./logos/motorsport/ireland-logo-icon.png": 53286,
	"./logos/motorsport/joburg-super-kings-logo-icon.png": 1601,
	"./logos/motorsport/lcr-honda-logo-icon.webp": 6194,
	"./logos/motorsport/mi-cape-town-logo-icon.png": 16780,
	"./logos/motorsport/monster-energy-yamaha-logo-icon.webp": 89615,
	"./logos/motorsport/netherlands-logo-icon.png": 68463,
	"./logos/motorsport/new-zealand-logo-icon.png": 81673,
	"./logos/motorsport/paarl-royals-logo-icon.png": 29550,
	"./logos/motorsport/pakistan-logo-icon.png": 45942,
	"./logos/motorsport/pertamina-enduro-vr46-logo-icon.webp": 58974,
	"./logos/motorsport/pretoria-capitals-logo-icon.png": 38465,
	"./logos/motorsport/prima-endura-racing-logo-icon.webp": 92716,
	"./logos/motorsport/redbull-gasgas-tech3-logo-icon.webp": 40003,
	"./logos/motorsport/redbull-ktm-logo-icon.webp": 40309,
	"./logos/motorsport/south-africa-logo-icon.png": 65633,
	"./logos/motorsport/sri-lanka-logo-icon.png": 47981,
	"./logos/motorsport/sunrisers-eastern-cape-logo-icon.png": 29306,
	"./logos/motorsport/trackhouse-racing-logo-icon.webp": 17366,
	"./logos/motorsport/zimbabwe-logo-icon.png": 79936,
	"./logos/rugby/argentina-logo-icon.webp": 1539,
	"./logos/rugby/australia-logo-icon.webp": 19776,
	"./logos/rugby/benetton-rugby-logo-icon.webp": 4733,
	"./logos/rugby/blue-bulls-logo-icon.webp": 48713,
	"./logos/rugby/boland-kavaliers-logo-icon.webp": 20527,
	"./logos/rugby/bulls-logo-icon.webp": 62784,
	"./logos/rugby/canada-logo-icon.png": 95871,
	"./logos/rugby/canada-logo-icon.webp": 60060,
	"./logos/rugby/cardiff-rugby-logo-icon.webp": 27801,
	"./logos/rugby/chile-logo-icon.webp": 99987,
	"./logos/rugby/colombia-logo-icon.png": 47543,
	"./logos/rugby/connacht-rugby-logo-icon.webp": 8166,
	"./logos/rugby/default-logo-icon.webp": 40959,
	"./logos/rugby/dragons-rfc-logo-icon.webp": 30782,
	"./logos/rugby/edinburgh-rugby-logo-icon.webp": 68640,
	"./logos/rugby/england-logo-icon.webp": 75299,
	"./logos/rugby/fiji-logo-icon.webp": 37030,
	"./logos/rugby/france-logo-icon.webp": 50737,
	"./logos/rugby/georgia-logo-icon.webp": 3682,
	"./logos/rugby/glasgow-warriors-logo-icon.webp": 85324,
	"./logos/rugby/griquas-logo-icon.webp": 75431,
	"./logos/rugby/hong-kong-logo-icon.webp": 62458,
	"./logos/rugby/ireland-logo-icon.webp": 11689,
	"./logos/rugby/italy-logo-icon.webp": 78425,
	"./logos/rugby/japan-logo-icon.webp": 9786,
	"./logos/rugby/leinster-rugby-logo-icon.webp": 76388,
	"./logos/rugby/lions-logo-icon.webp": 86537,
	"./logos/rugby/mexico-logo-icon.png": 31908,
	"./logos/rugby/munster-rugby-logo-icon.webp": 62284,
	"./logos/rugby/new-zealand-logo-icon.webp": 21372,
	"./logos/rugby/ospreys-logo-icon.webp": 45413,
	"./logos/rugby/portugal-logo-icon.webp": 14564,
	"./logos/rugby/pumas-logo-icon.webp": 65756,
	"./logos/rugby/romania-logo-icon.png": 7760,
	"./logos/rugby/romania-logo-icon.webp": 75325,
	"./logos/rugby/samoa-logo-icon.webp": 88329,
	"./logos/rugby/scarlets-logo-icon.webp": 24217,
	"./logos/rugby/scotland-logo-icon.webp": 62082,
	"./logos/rugby/sharks-logo-icon.webp": 79884,
	"./logos/rugby/sharks-xv-logo-icon.webp": 52913,
	"./logos/rugby/south-africa-logo-icon.webp": 89892,
	"./logos/rugby/spain-logo-icon.webp": 76763,
	"./logos/rugby/stormers-logo-icon.webp": 19209,
	"./logos/rugby/tonga-logo-icon.webp": 52455,
	"./logos/rugby/toyota-cheetahs-logo-icon.webp": 43652,
	"./logos/rugby/ulster-rugby-logo-icon.webp": 58597,
	"./logos/rugby/uruguay-logo-icon.webp": 31166,
	"./logos/rugby/usa-logo-icon.webp": 79613,
	"./logos/rugby/wales-logo-icon.webp": 71114,
	"./logos/rugby/western-province-logo-icon.webp": 52075,
	"./logos/rugby/zebre-parma-logo-icon.webp": 5046,
	"./logos/soccer/aek-athens-logo-icon.png": 44760,
	"./logos/soccer/afc-bournemouth-logo-icon.png": 41774,
	"./logos/soccer/ajaccio-logo-icon.png": 76313,
	"./logos/soccer/ajax-logo-icon.png": 88699,
	"./logos/soccer/alaves-logo-icon.png": 95391,
	"./logos/soccer/albania-logo-icon.png": 98285,
	"./logos/soccer/algeria-logo-icon.png": 62880,
	"./logos/soccer/almeria-logo-icon.png": 32406,
	"./logos/soccer/amazulu-logo-icon.png": 5764,
	"./logos/soccer/angers-sco-logo-icon.png": 71747,
	"./logos/soccer/angola-logo-icon.png": 89887,
	"./logos/soccer/antwerp-logo-icon.png": 44860,
	"./logos/soccer/argentina-logo-icon.png": 98366,
	"./logos/soccer/aris-limassol-logo-icon.png": 37171,
	"./logos/soccer/arsenal-logo-icon.png": 76391,
	"./logos/soccer/astana-logo-icon.png": 27239,
	"./logos/soccer/aston-villa-logo-icon.png": 18081,
	"./logos/soccer/atalanta-logo-icon.png": 74449,
	"./logos/soccer/athletic-club-logo-icon.png": 66708,
	"./logos/soccer/atletic-club-d'escaldes-logo-icon.png": 3030,
	"./logos/soccer/atletico-madrid-logo-icon.png": 23728,
	"./logos/soccer/australia-logo-icon.png": 43287,
	"./logos/soccer/austria-logo-icon.png": 32932,
	"./logos/soccer/auxerre-logo-icon.png": 37365,
	"./logos/soccer/ballkani-logo-icon.png": 16957,
	"./logos/soccer/barcelona-logo-icon.png": 12261,
	"./logos/soccer/baroka-logo-icon.png": 28571,
	"./logos/soccer/bate-logo-icon.png": 97899,
	"./logos/soccer/bayer-leverkusen-logo-icon.png": 82285,
	"./logos/soccer/bayern-munchen-logo-icon.png": 89467,
	"./logos/soccer/belgium-logo-icon.png": 34882,
	"./logos/soccer/benfica-logo-icon.png": 6257,
	"./logos/soccer/bodo-glimt-logo-icon.png": 25041,
	"./logos/soccer/bologna-logo-icon.png": 95443,
	"./logos/soccer/bordeaux-logo-icon.png": 64831,
	"./logos/soccer/borussia-dortmund-logo-icon.png": 49671,
	"./logos/soccer/braga-logo-icon.png": 61120,
	"./logos/soccer/brazil-logo-icon.png": 80467,
	"./logos/soccer/breidablik-logo-icon.png": 56092,
	"./logos/soccer/brentford-logo-icon.png": 40241,
	"./logos/soccer/brest-logo-icon.png": 96309,
	"./logos/soccer/brighton-&-hove-albion-logo-icon.png": 74090,
	"./logos/soccer/buducnost-logo-icon.png": 35000,
	"./logos/soccer/burkina-faso-logo-icon.png": 78593,
	"./logos/soccer/burnley-logo-icon.png": 21038,
	"./logos/soccer/cabo-verde-logo-icon.png": 36153,
	"./logos/soccer/cadiz-logo-icon.png": 80852,
	"./logos/soccer/cagliari-logo-icon.png": 7925,
	"./logos/soccer/cameroon-logo-icon.png": 98509,
	"./logos/soccer/canada-logo-icon.png": 66107,
	"./logos/soccer/cape-town-city-logo-icon.png": 73375,
	"./logos/soccer/cape-town-spurs-logo-icon.png": 53491,
	"./logos/soccer/celta-de-vigo-logo-icon.png": 56544,
	"./logos/soccer/celtic-logo-icon.png": 68445,
	"./logos/soccer/chelsea-logo-icon.png": 99334,
	"./logos/soccer/china-pr-logo-icon.png": 9085,
	"./logos/soccer/chippa-united-logo-icon.png": 31844,
	"./logos/soccer/clermont-logo-icon.png": 89535,
	"./logos/soccer/club-brugge-logo-icon.png": 43868,
	"./logos/soccer/colombia-logo-icon.png": 70355,
	"./logos/soccer/como-logo-icon.png": 85591,
	"./logos/soccer/congo-dr-logo-icon.png": 56312,
	"./logos/soccer/costa-rica-logo-icon.png": 43619,
	"./logos/soccer/cote-d'ivoire-logo-icon.png": 69028,
	"./logos/soccer/cremonese-logo-icon.png": 43174,
	"./logos/soccer/croatia-logo-icon.png": 43398,
	"./logos/soccer/crvena-zvezda-logo-icon.png": 21053,
	"./logos/soccer/crystal-palace-logo-icon.png": 76902,
	"./logos/soccer/czech-republic-logo-icon.png": 91599,
	"./logos/soccer/denmark-logo-icon.png": 24795,
	"./logos/soccer/deportivo-alaves-logo-icon.png": 26218,
	"./logos/soccer/dinamo-tbilisi-logo-icon.png": 2150,
	"./logos/soccer/dinamo-zagreb-logo-icon.png": 31795,
	"./logos/soccer/durban-city-logo-icon.png": 10369,
	"./logos/soccer/dynamo-kyiv-logo-icon.png": 96643,
	"./logos/soccer/ecuador-logo-icon.png": 84480,
	"./logos/soccer/egypt-logo-icon.png": 55812,
	"./logos/soccer/eintracht-frankfurt-logo-icon.png": 43477,
	"./logos/soccer/elche-logo-icon.png": 68458,
	"./logos/soccer/empoli-logo-icon.png": 23521,
	"./logos/soccer/england-logo-icon.png": 62278,
	"./logos/soccer/equatorial-guinea-logo-icon.png": 77326,
	"./logos/soccer/espanyol-logo-icon.png": 67418,
	"./logos/soccer/everton-logo-icon.png": 38266,
	"./logos/soccer/ferencvaros-logo-icon.png": 73019,
	"./logos/soccer/feyenoord-logo-icon.png": 5856,
	"./logos/soccer/fiorentina-logo-icon.png": 99962,
	"./logos/soccer/flora-logo-icon.png": 16427,
	"./logos/soccer/france-logo-icon.png": 92128,
	"./logos/soccer/frosinone-logo-icon.png": 22964,
	"./logos/soccer/fulham-logo-icon.png": 81676,
	"./logos/soccer/galatasaray-logo-icon.png": 43065,
	"./logos/soccer/gambia-logo-icon.png": 36338,
	"./logos/soccer/genoa-logo-icon.png": 89979,
	"./logos/soccer/georgia-logo-icon.png": 96253,
	"./logos/soccer/germany-logo-icon.png": 2310,
	"./logos/soccer/getafe-logo-icon.png": 21843,
	"./logos/soccer/ghana-logo-icon.png": 532,
	"./logos/soccer/girona-logo-icon.png": 19183,
	"./logos/soccer/golden-arrows-logo-icon.png": 84463,
	"./logos/soccer/granada-logo-icon.png": 78319,
	"./logos/soccer/guinea-bissau-logo-icon.png": 60974,
	"./logos/soccer/guinea-logo-icon.png": 71330,
	"./logos/soccer/hacken-logo-icon.png": 59239,
	"./logos/soccer/haiti-logo-icon.png": 43954,
	"./logos/soccer/hamrun-spartans-logo-icon.png": 43607,
	"./logos/soccer/hellas-verona-logo-icon.png": 85466,
	"./logos/soccer/hjk-logo-icon.png": 70780,
	"./logos/soccer/hungary-logo-icon.png": 64483,
	"./logos/soccer/internazionale-logo-icon.png": 63334,
	"./logos/soccer/ipswich-town-logo-icon.png": 1333,
	"./logos/soccer/iran-logo-icon.png": 31041,
	"./logos/soccer/italy-logo-icon.png": 44952,
	"./logos/soccer/jamaica-logo-icon.png": 619,
	"./logos/soccer/japan-logo-icon.png": 41437,
	"./logos/soccer/juventus-logo-icon.png": 59443,
	"./logos/soccer/kairat-logo-icon.png": 35791,
	"./logos/soccer/kairat-logo-icon.webp": 41900,
	"./logos/soccer/kaizer-chiefs-logo-icon.png": 30286,
	"./logos/soccer/ki-logo-icon.png": 5953,
	"./logos/soccer/kobenhavn-logo-icon.png": 11173,
	"./logos/soccer/korea-republic-logo-icon.png": 92766,
	"./logos/soccer/larne-logo-icon.png": 80227,
	"./logos/soccer/las-palmas-logo-icon.png": 18708,
	"./logos/soccer/lazio-logo-icon.png": 54172,
	"./logos/soccer/le-havre-logo-icon.png": 54429,
	"./logos/soccer/lecce-logo-icon.png": 65597,
	"./logos/soccer/leeds-united-logo-icon.png": 68402,
	"./logos/soccer/leganes-logo-icon.png": 2488,
	"./logos/soccer/leicester-city-logo-icon.png": 73315,
	"./logos/soccer/lens-logo-icon.png": 40029,
	"./logos/soccer/levante-logo-icon.png": 83932,
	"./logos/soccer/lille-logo-icon.png": 57687,
	"./logos/soccer/lincoln-red-imps-logo-icon.png": 64892,
	"./logos/soccer/liverpool-logo-icon.png": 41743,
	"./logos/soccer/lorient-logo-icon.png": 7578,
	"./logos/soccer/ludogorets-logo-icon.png": 78849,
	"./logos/soccer/luton-town-logo-icon.png": 65712,
	"./logos/soccer/maccabi-haifa-logo-icon.png": 13513,
	"./logos/soccer/magesi-logo-icon.png": 54699,
	"./logos/soccer/mali-logo-icon.png": 15070,
	"./logos/soccer/mallorca-logo-icon.png": 51852,
	"./logos/soccer/mamelodi-sundowns-logo-icon.png": 96879,
	"./logos/soccer/manchester-city-logo-icon.png": 79787,
	"./logos/soccer/manchester-united-logo-icon.png": 87391,
	"./logos/soccer/maritzburg-united-logo-icon.png": 69546,
	"./logos/soccer/marumo-gallants-logo-icon.png": 22153,
	"./logos/soccer/mauritania-logo-icon.png": 46006,
	"./logos/soccer/metz-logo-icon.png": 61189,
	"./logos/soccer/mexico-logo-icon.png": 36808,
	"./logos/soccer/milan-logo-icon.png": 20330,
	"./logos/soccer/molde-logo-icon.png": 2084,
	"./logos/soccer/monaco-logo-icon.png": 50816,
	"./logos/soccer/montpellier-logo-icon.png": 50348,
	"./logos/soccer/monza-logo-icon.png": 25944,
	"./logos/soccer/morocco-logo-icon.png": 2355,
	"./logos/soccer/mozambique-logo-icon.png": 93163,
	"./logos/soccer/namibia-logo-icon.png": 13830,
	"./logos/soccer/nantes-logo-icon.png": 24936,
	"./logos/soccer/napoli-logo-icon.png": 35928,
	"./logos/soccer/netherlands-logo-icon.png": 17777,
	"./logos/soccer/new-zealand-logo-icon.png": 14947,
	"./logos/soccer/newcastle-united-logo-icon.png": 27935,
	"./logos/soccer/nice-logo-icon.png": 99974,
	"./logos/soccer/nigeria-logo-icon.png": 14484,
	"./logos/soccer/norway-logo-icon.png": 41903,
	"./logos/soccer/norwich-logo-icon.png": 33977,
	"./logos/soccer/nottingham-forest-logo-icon.png": 99226,
	"./logos/soccer/olimpija-logo-icon.png": 27940,
	"./logos/soccer/olympiakos-piraeus-logo-icon.png": 18381,
	"./logos/soccer/olympiakos-piraeus-logo-icon.webp": 24030,
	"./logos/soccer/olympique-lyonnais-logo-icon.png": 59110,
	"./logos/soccer/olympique-marseille-logo-icon.png": 36297,
	"./logos/soccer/orbit-college-logo-icon.png": 48757,
	"./logos/soccer/orlando-pirates-logo-icon.png": 58739,
	"./logos/soccer/osasuna-logo-icon.png": 86501,
	"./logos/soccer/pafos-logo-icon.png": 38790,
	"./logos/soccer/pafos-logo-icon.webp": 93679,
	"./logos/soccer/panama-logo-icon.png": 59853,
	"./logos/soccer/panathinaikos-logo-icon.png": 33755,
	"./logos/soccer/paris-fc-logo-icon.png": 31094,
	"./logos/soccer/parma-logo-icon.png": 64806,
	"./logos/soccer/partizani-tirana-logo-icon.png": 493,
	"./logos/soccer/philippines-logo-icon.png": 59696,
	"./logos/soccer/pisa-logo-icon.png": 8888,
	"./logos/soccer/poland-logo-icon.png": 44285,
	"./logos/soccer/polokwane-city-logo-icon.png": 58925,
	"./logos/soccer/porto-logo-icon.png": 21285,
	"./logos/soccer/portugal-logo-icon.png": 78651,
	"./logos/soccer/psg-logo-icon.png": 75683,
	"./logos/soccer/psv-logo-icon.png": 8050,
	"./logos/soccer/qarabag-logo-icon.png": 3476,
	"./logos/soccer/qatar-logo-icon.png": 73530,
	"./logos/soccer/rakow-czestochowa-logo-icon.png": 91270,
	"./logos/soccer/rangers-logo-icon.png": 94395,
	"./logos/soccer/rayo-vallecano-logo-icon.png": 33380,
	"./logos/soccer/rb-leipzig-logo-icon.png": 14090,
	"./logos/soccer/real-betis-logo-icon.png": 59959,
	"./logos/soccer/real-madrid-logo-icon.png": 57579,
	"./logos/soccer/real-oviedo-logo-icon.png": 77902,
	"./logos/soccer/real-sociedad-logo-icon.png": 47258,
	"./logos/soccer/real-valladolid-logo-icon.png": 69398,
	"./logos/soccer/reims-logo-icon.png": 80829,
	"./logos/soccer/rennes-logo-icon.png": 46994,
	"./logos/soccer/republic-of-ireland-logo-icon.png": 1441,
	"./logos/soccer/richards-bay-logo-icon.png": 12094,
	"./logos/soccer/roma-logo-icon.png": 70926,
	"./logos/soccer/romania-logo-icon.png": 82140,
	"./logos/soccer/royal-am-logo-icon.png": 75429,
	"./logos/soccer/saint-etienne-logo-icon.png": 58875,
	"./logos/soccer/salernitana-logo-icon.png": 1093,
	"./logos/soccer/salzburg-logo-icon.png": 62209,
	"./logos/soccer/sampdoria-logo-icon.png": 3313,
	"./logos/soccer/sassuolo-logo-icon.png": 88172,
	"./logos/soccer/saudi-arabia-logo-icon.png": 16714,
	"./logos/soccer/scotland-logo-icon.png": 13261,
	"./logos/soccer/sekhukhune-united-logo-icon.png": 19420,
	"./logos/soccer/senegal-logo-icon.png": 7132,
	"./logos/soccer/serbia-logo-icon.png": 15471,
	"./logos/soccer/servette-logo-icon.png": 32659,
	"./logos/soccer/sevilla-logo-icon.png": 67589,
	"./logos/soccer/shakhtar-donetsk-logo-icon.png": 57876,
	"./logos/soccer/shamrock-rovers-logo-icon.png": 45115,
	"./logos/soccer/sheffield-united-logo-icon.png": 41765,
	"./logos/soccer/sheriff-logo-icon.png": 7120,
	"./logos/soccer/siwelele-logo-icon.png": 40305,
	"./logos/soccer/slavia-praha-logo-icon.png": 65362,
	"./logos/soccer/slovakia-logo-icon.png": 40549,
	"./logos/soccer/slovan-bratislava-logo-icon.png": 94668,
	"./logos/soccer/slovenia-logo-icon.png": 42528,
	"./logos/soccer/south-africa-logo-icon.png": 57611,
	"./logos/soccer/southampton-logo-icon.png": 69815,
	"./logos/soccer/spain-logo-icon.png": 7558,
	"./logos/soccer/sparta-praha-logo-icon.png": 32197,
	"./logos/soccer/spezia-logo-icon.png": 30431,
	"./logos/soccer/sporting-braga-logo-icon.png": 13429,
	"./logos/soccer/sporting-cp-logo-icon.png": 82299,
	"./logos/soccer/stade-brestois-logo-icon.png": 15446,
	"./logos/soccer/stellenbosch-logo-icon.png": 20205,
	"./logos/soccer/strasbourg-logo-icon.png": 30429,
	"./logos/soccer/struga-logo-icon.png": 88639,
	"./logos/soccer/sturm-graz-logo-icon.png": 73761,
	"./logos/soccer/stuttgart-logo-icon.png": 87497,
	"./logos/soccer/sunderland-logo-icon.png": 11753,
	"./logos/soccer/supersport-united-logo-icon.png": 48650,
	"./logos/soccer/swallows-logo-icon.png": 66525,
	"./logos/soccer/sweden-logo-icon.png": 35085,
	"./logos/soccer/swift-hesperange-logo-icon.png": 44371,
	"./logos/soccer/switzerland-logo-icon.png": 63174,
	"./logos/soccer/tanzania-logo-icon.png": 81287,
	"./logos/soccer/the-new-saints-logo-icon.png": 1978,
	"./logos/soccer/torino-logo-icon.png": 55780,
	"./logos/soccer/tottenham-hotspur-logo-icon.png": 17987,
	"./logos/soccer/toulouse-logo-icon.png": 28885,
	"./logos/soccer/trabzonspor-logo-icon.png": 13463,
	"./logos/soccer/tre-penne-logo-icon.png": 16607,
	"./logos/soccer/troyes-logo-icon.png": 74691,
	"./logos/soccer/ts-galaxy-logo-icon.png": 9065,
	"./logos/soccer/tsc-logo-icon.png": 92067,
	"./logos/soccer/tunisia-logo-icon.png": 55362,
	"./logos/soccer/turkey-logo-icon.png": 35939,
	"./logos/soccer/udinese-logo-icon.png": 87738,
	"./logos/soccer/ukraine-logo-icon.png": 88874,
	"./logos/soccer/union-berlin-logo-icon.png": 90303,
	"./logos/soccer/union-saint-gilloise-logo-icon.png": 78107,
	"./logos/soccer/union-saint-gilloise-logo-icon.webp": 71808,
	"./logos/soccer/united-states-logo-icon.png": 17473,
	"./logos/soccer/urartu-logo-icon.png": 39472,
	"./logos/soccer/uruguay-logo-icon.png": 32257,
	"./logos/soccer/valencia-logo-icon.png": 63728,
	"./logos/soccer/valladolid-logo-icon.png": 57803,
	"./logos/soccer/valmiera-logo-icon.png": 36082,
	"./logos/soccer/venezia-logo-icon.png": 84113,
	"./logos/soccer/vietnam-logo-icon.png": 4581,
	"./logos/soccer/viitorul-logo-icon.png": 15673,
	"./logos/soccer/viktoria-plzen-logo-icon.png": 75814,
	"./logos/soccer/villarreal-logo-icon.png": 76535,
	"./logos/soccer/wales-logo-icon.png": 80685,
	"./logos/soccer/west-ham-united-logo-icon.png": 20697,
	"./logos/soccer/wolverhampton-wanderers-logo-icon.png": 81769,
	"./logos/soccer/young-boys-logo-icon.png": 40953,
	"./logos/soccer/zalgiris-logo-icon.png": 86872,
	"./logos/soccer/zambia-logo-icon.png": 75269,
	"./logos/soccer/zrinjski-logo-icon.png": 17513,
	"./menu-icon.png": 77407,
	"./navBar/coming-soon-icon.png": 58880,
	"./navBar/fixtures-active.png": 92050,
	"./navBar/fixtures-inactive.png": 42615,
	"./navBar/home-active.png": 62731,
	"./navBar/home-inactive.png": 5586,
	"./navBar/live-active.png": 49246,
	"./navBar/live-coming-soon.png": 66717,
	"./navBar/live-inactive.png": 47659,
	"./navBar/news-active.png": 42315,
	"./navBar/news-inactive.png": 84722,
	"./navBar/profile-active.png": 68157,
	"./navBar/profile-inactive.png": 2944,
	"./news/cricket-asset.png": 29726,
	"./news/dribble-asset.png": 99197,
	"./news/expand-icon.png": 37434,
	"./news/f1-asset.png": 69110,
	"./news/hide-icon.png": 66274,
	"./news/lightining-icon.png": 96519,
	"./news/play-btn.png": 44499,
	"./news/play-icon.png": 5216,
	"./news/rugby-asset.png": 84966,
	"./news/share-icon.png": 93223,
	"./onboarding/benefits-icon.png": 70324,
	"./onboarding/close-icon.png": 21530,
	"./onboarding/subscribe-logo.png": 33752,
	"./profile/add-teams-btn.png": 59883,
	"./profile/cricket-asset.png": 438,
	"./profile/cricket-teams-icon.png": 45444,
	"./profile/dribble-asset.png": 82293,
	"./profile/edit-icon.png": 66902,
	"./profile/f1-asset.png": 18654,
	"./profile/f1-teams-icon.png": 92524,
	"./profile/profile-bg.png": 12587,
	"./profile/profile-image/animoji-active-1.png": 99054,
	"./profile/profile-image/animoji-active-10.png": 56300,
	"./profile/profile-image/animoji-active-11.png": 67925,
	"./profile/profile-image/animoji-active-12.png": 47550,
	"./profile/profile-image/animoji-active-2.png": 17829,
	"./profile/profile-image/animoji-active-3.png": 316,
	"./profile/profile-image/animoji-active-4.png": 83923,
	"./profile/profile-image/animoji-active-5.png": 33162,
	"./profile/profile-image/animoji-active-6.png": 82145,
	"./profile/profile-image/animoji-active-7.png": 9432,
	"./profile/profile-image/animoji-active-8.png": 11087,
	"./profile/profile-image/animoji-active-9.png": 25990,
	"./profile/profile-image/animoji-inactive-1.png": 54115,
	"./profile/profile-image/animoji-inactive-10.png": 73291,
	"./profile/profile-image/animoji-inactive-11.png": 9634,
	"./profile/profile-image/animoji-inactive-12.png": 23641,
	"./profile/profile-image/animoji-inactive-2.png": 17256,
	"./profile/profile-image/animoji-inactive-3.png": 11121,
	"./profile/profile-image/animoji-inactive-4.png": 44382,
	"./profile/profile-image/animoji-inactive-5.png": 96871,
	"./profile/profile-image/animoji-inactive-6.png": 77868,
	"./profile/profile-image/animoji-inactive-7.png": 30133,
	"./profile/profile-image/animoji-inactive-8.png": 59282,
	"./profile/profile-image/animoji-inactive-9.png": 74107,
	"./profile/rugby-asset.png": 8846,
	"./profile/rugby-teams-icon.png": 54332,
	"./profile/soccer-teams-icon.png": 55278,
	"./standing-arrow-dot.svg": 30732,
	"./styles/_modal-common.scss": 32940,
	"./styles/_subscription-overlay.scss": 53817,
	"./styles/_tokens.scss": 39679,
	"./styles/main.scss": 7649,
	"./trivia/trivia-icon-active.png": 90410,
	"./trivia/trivia-icon-inactive.png": 3727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;